import apiFetch from '../apiFetch'

export default function (value, token) {
  return apiFetch({endPoint: `ImportarLineasPedidosExcel`, method: 'POST', body: value, token: token})
}
